import clsx from 'clsx';

import styles from './Hint.module.scss';

type GetHintClassesOptions = {
  className?: string;
};

export const getHintClasses = ({
  className,
}: GetHintClassesOptions = {}): string => {
  return clsx(styles.hint, className);
};
